var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltroDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1376",
    "data-name": "Grupo 1376",
    transform: "translate(-416 -2851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1370",
    "data-name": "Grupo 1370",
    transform: "translate(8.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_973",
    "data-name": "Caminho 973",
    d: "M0,0H27V27H0Z",
    transform: "translate(407.563 2851)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1368",
    "data-name": "Grupo 1368",
    transform: "translate(409.81 2853.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1363",
    "data-name": "Grupo 1363",
    transform: "translate(3.513 4.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_975",
    "data-name": "Caminho 975",
    d: "M317.573,307.945h-.046v-1.828a1.175,1.175,0,0,0-.042-.327,1.11,1.11,0,0,0-1.093-.8c-.631,0-1.263,0-1.894,0a.318.318,0,0,0-.046,0,1.983,1.983,0,0,0-.06-.328,1.018,1.018,0,0,0-.531-.762c-.028-.013-.051-.032-.078-.045a8.914,8.914,0,0,0-6.774-.663.562.562,0,0,0-.236.137,1.957,1.957,0,0,0-.539,1.048,3.363,3.363,0,0,0,.005,1.246.5.5,0,0,0,.146.325,9.167,9.167,0,0,0,1.194.918c-.466.115-.977.247-.977.247a.173.173,0,0,0-.173.174V309.3h.971a.865.865,0,1,0,1.718.141.83.83,0,0,0-.017-.139h.4a.891.891,0,0,0-.012.164.868.868,0,0,0,1.735-.018.832.832,0,0,0-.015-.145l3.608,0a.809.809,0,0,0-.012.162.866.866,0,0,0,1.731-.028.959.959,0,0,0-.015-.135H317.7a.286.286,0,0,0,.045-.006v-1.185A.173.173,0,0,0,317.573,307.945Z",
    transform: "translate(-306.178 -302.803)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_976",
    "data-name": "Caminho 976",
    d: "M321.988,318.887l2.125-2.126L320.3,312.94,318.387,311a9.292,9.292,0,1,0-2.227,2.2l1.848,1.711Zm-11.082-5.645a7.562,7.562,0,1,1,7.563-7.562A7.552,7.552,0,0,1,310.906,313.242Z",
    transform: "translate(-301.609 -296.382)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltroDashboard);
export default __webpack_public_path__ + "static/media/filtro-dashboard.e9dd5f0b8b93f684448c49a6239f60d3.svg";
export { ForwardRef as ReactComponent };